import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import { addClickCallbackToLink, removeClickCallback, formatString } from '../../utils/Formatter';

export default class FormList extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    getMultipleFormMessage(item){
        let message = '';
        if (!item){
            return message;
        }
        let value = item.value.split('__');
        if (value && value.length > 0 && value[0]){
            message = this.props.content[value[0]];
        }

        return message;
    }

    renderGroupings(){
        return(<div>
            {this.props.groups.map(function(group, idx){
                let list = _.filter(this.props.formList, {group: group});
                if (list && list.length > 0){
                    return (<div key={`formGroup__${idx}`}>
                            <h4>{group}</h4>
                            {this.renderList(list)}
                        </div>);    
                }
                else{
                    return null;
                }
            }.bind(this))}
        </div>);
    }

    renderList(list){
        if (!list){
            return null;
        }
        let message = '';
        return(<div>
                {list.map(function(item, idx){
                    if (item.value.indexOf('__') > 0){
                        let index = item.value.split('__');
                        let name = item.name ? ' - ' + item.name : '';
                        message = formatString(this.getMultipleFormMessage(item), {idx: `__${index[1]}`, name: name});
                    }
                    else{
                        message = formatString(this.props.content[item.value], {name: ''});
                    }
                    return (<div key={`form__${idx}`}>
                                <div dangerouslySetInnerHTML={{__html: message}}></div>
                            </div>);
                }.bind(this))}
            </div>);
    }

    render() {
        if (!this.props.formList || !this.props.formList.length || !this.props.content){
            return null;
        }
        if (this.props.groups){
            return <div className="spacing__bottom-12px">{this.renderGroupings()}</div>
        }
        else{
            return <div className="spacing__bottom-12px">{this.renderList(this.props.formList)}</div>
        }
    }

    download(e){
        if (this.props.downloadFileCallBack){
            this.props.downloadFileCallBack(e);
        }
    }

    componentDidMount(){
        if (this.props.formList){
            _.forEach(this.props.formList, function(item){
                addClickCallbackToLink(item.value, this.download)
            }.bind(this));
        }
    }

    componentWillUnmount(){
        if (this.props.formList){
            _.forEach(this.props.formList, function(item){
                removeClickCallback(item.value, this.download)
            }.bind(this));
        }
    }
}

FormList.propTypes = {
    formList: React.PropTypes.array.isRequired,
    content: React.PropTypes.object.isRequired,
    downloadFileCallBack: React.PropTypes.func,
    groups: React.PropTypes.array
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Congratulations/FormList.jsx